import superMeta from '../_BASE/metaBaseNode.mjs'

export default {
    ...superMeta,
}
